export default {
  loading: "Loading...",
  totalData: "records",
  totalPrefix: "Total",
  download: "Download",
  downloadDetails: "Download Details",
  noData: "No Data",
  columns: {
    direction: "Direction",
    totalCount: "Count",
    currency: "Crypto",
    totalQuantity: "Total Quantity",
  },
  directions: {
    buy: "Buy",
    sell: "Sell",
    unknown: "Unknown",
  },
};
